import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms'; // Importe o FormsModule
import { AuthService } from '../../services/auth.service'; // Ajuste o caminho conforme necessário
import Swal from 'sweetalert2';

@Component({
  selector: 'app-signup',
  standalone: true,
  imports: [RouterModule, FormsModule], // Adicione o FormsModule aqui
  templateUrl: './signup.component.html',
  styleUrl: './signup.component.scss'
})
export class SignupComponent {
  userData = {
    name: '',
    email: '',
    phone: '',
    address: '',
    district: '',
    city: '',
    UF: '',
    CEP: '',
    picture: '',
    birth: '',
    plan: '',
    password: '',
    confirmPassword: '',
    terms: false
  };

  isLoading = false; 

  constructor(private authService: AuthService) {}

  onSubmit() {
    // Impede múltiplos envios
    if (this.isLoading) {
      return;
    }

    // Validação de senha
    if (this.userData.password !== this.userData.confirmPassword) {
      Swal.fire({
        text: 'As senhas não coincidem!',
        icon: 'error',
        toast: true,
        position: 'bottom-end', 
        showConfirmButton: false, 
        timer: 4000, 
        timerProgressBar: true
      });
      return;
    }

    // Validação dos termos
    if (!this.userData.terms) {
      Swal.fire({
        text: 'Você deve concordar com os termos de serviço!',
        icon: 'error',
        toast: true,
        position: 'bottom-end', 
        showConfirmButton: false, 
        timer: 4000, 
        timerProgressBar: true
      });
      return;
    }

    this.isLoading = true; // Inicia o estado de carregamento

    // Chama o método de cadastro do AuthService
    this.authService.signup({
      name: this.userData.name,
      email: this.userData.email,
      phone: this.userData.phone,
      address: this.userData.address,
      district: this.userData.district,
      city: this.userData.city,
      UF: this.userData.UF,
      birth: this.userData.birth,
      password: this.userData.password
    }).subscribe({
      next: (res) => {
        this.isLoading = false; // Finaliza o carregamento
        Swal.fire({
          title: 'Cadastro realizado com sucesso! 🎉',
          text: 'Parabéns! 🎊👏',
          icon: 'success',
          confirmButtonText: 'OK 👍'
        });
      },
      error: (err) => {
        this.isLoading = false; 
        console.error('Erro ao cadastrar:', err);
        const errorMessage = err.error?.message || 'Ocorreu um erro ao cadastrar!';
        
        Swal.fire({
          text: errorMessage,
          icon: 'error',
          toast: true,
          position: 'bottom-end', 
          showConfirmButton: false, 
          timer: 4000, 
          timerProgressBar: true
        });
      }
    });
  }
}
